/**
 * Sprint T-17.1 · Notification Center · DeliveryRow.
 * Row de tabla · clickable · abre drawer.
 */
import React from "react";
import { ChevronRight } from "lucide-react";
import { RelativeTime } from "../../automationCenter/shared/Formatters";
import ChannelIcon from "./ChannelIcon";
import StatusPill from "./StatusPill";

export default function DeliveryRow({ delivery, onSelect, index }) {
  const testId = `notif-delivery-row-${index}`;
  return (
    <tr
      data-testid={testId}
      onClick={() => onSelect?.(delivery)}
      className="cursor-pointer border-b border-[var(--ag-border)] hover:bg-[var(--ag-surface-2)]/40"
    >
      <td className="px-2 py-2 text-[10px]">
        <RelativeTime iso={delivery.finished_at || delivery.started_at} />
      </td>
      <td className="px-2 py-2">
        <ChannelIcon channel={delivery.channel} />
      </td>
      <td className="px-2 py-2">
        <StatusPill status={delivery.status} testId={`${testId}-status`} />
      </td>
      <td
        className="max-w-[220px] truncate px-2 py-2 font-mono text-[10px]"
        title={delivery.to}
      >
        {delivery.to || "—"}
      </td>
      <td
        className="max-w-[240px] truncate px-2 py-2 font-mono text-[10px] text-[var(--ag-text-dim)]"
        title={delivery.template_id}
      >
        {delivery.template_id}
      </td>
      <td className="px-2 py-2 text-[10px]">
        <span className="rounded border border-[var(--ag-border)] bg-[var(--ag-surface-2)] px-1.5 py-0.5 font-mono">
          {delivery.provider_name || "—"}
        </span>
      </td>
      <td className="px-2 py-2 text-right font-mono text-[10px] tabular-nums">
        {delivery.attempt}
      </td>
      <td className="px-2 py-2 text-right font-mono text-[10px] tabular-nums text-[var(--ag-text-dim)]">
        {delivery.latency_ms ? `${delivery.latency_ms}ms` : "—"}
      </td>
      <td className="px-2 py-2 text-[10px]">
        {delivery.dry_run && (
          <span
            data-testid={`${testId}-dryrun`}
            className="rounded border border-amber-500/30 bg-amber-500/10 px-1 py-0.5 text-[9px] uppercase tracking-wide text-amber-500"
          >
            dry-run
          </span>
        )}
      </td>
      <td className="px-2 py-2 text-[var(--ag-text-dim)]">
        <ChevronRight className="h-3 w-3" />
      </td>
    </tr>
  );
}
